import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingLegend from '../HarvestAndPlantingLegend';
import { getCurrentSeason } from '../../../../selectors';

function HarvestLegend(props) {
  return <HarvestAndPlantingLegend {...props} />;
}

HarvestLegend.propTypes = {
  dates: PropTypes.object.isRequired,
};

export function mapStateToProps(state, props) {
  const activeSeason = getCurrentSeason(state, props);
  const { list } = state.seasons;
  const { harvestEndDate, harvestStartDate, harvestYear } =
    list?.[activeSeason] ?? {};
  const dates = {
    endDate: harvestEndDate,
    startDate: harvestStartDate,
    year: harvestYear,
  };

  return {
    dates,
  };
}

export default connect(mapStateToProps)(HarvestLegend);
